import { Validators } from "@angular/forms";
import { required } from "@corporate-tailwind/corp-form";
import { SelectCode } from "@corporate-tailwind/model";

export class DueDiligenceFixedAnswerDto
{
    question: SelectCode | null = null;
    answer: SelectCode | null = null;
}

export class DueDiligenceFixedAnswerSchema extends DueDiligenceFixedAnswerDto {
    static schema = {
        question: { type: SelectCode, builderOption: required },
        answer: { type: SelectCode, builderOption: required }
    }
}

export class DueDiligenceTextAnswerDto
{
    question: SelectCode | null = null;
    answer: string | null = null;
}

export class DueDiligenceTextAnswerSchema extends DueDiligenceTextAnswerDto {
    static schema = {
        question: { type: SelectCode, builderOption: required },
        answer: { type: String, builderOption: required }
    }
}

export class DueDiligenceAdditionalDto
{
    question01: DueDiligenceTextAnswerDto | null = null;
    // question02: DueDiligenceTextAnswerDto | null = null;
}

export class DueDiligenceAdditionalSchema extends DueDiligenceAdditionalDto {
    static schema = {
        question01: { type: DueDiligenceTextAnswerSchema, builderOption: required }
        // question02: { type: DueDiligenceTextAnswerSchema, builderOption: required }
    }
}


export class DueDiligenceSelectionDto
{
    question01: SelectCode | null = null;
    answer01List: SelectCode[] | null = null;

    question02: SelectCode | null = null;
    answer02List: SelectCode[] | null = null;

    question03: SelectCode | null = null;
    answer03List: SelectCode[] | null = null;

    question04: SelectCode | null = null;
    question05: SelectCode | null = null;

}

export class DueDiligenceDto
{
    question01: DueDiligenceFixedAnswerDto | null = null;
    question02: DueDiligenceFixedAnswerDto | null = null;
    question03: DueDiligenceFixedAnswerDto | null = null;
    additionalQuestions: DueDiligenceAdditionalDto | null = null;
    isInformationCertified: boolean | null = null;
}

export class DueDiligenceSchema extends DueDiligenceDto {
    static schema = {
        question01: { type: DueDiligenceFixedAnswerSchema, builderOption: required },
        question02: { type: DueDiligenceFixedAnswerSchema, builderOption: required },
        question03: { type: DueDiligenceFixedAnswerSchema, builderOption: required },
        additionalQuestions: { type: DueDiligenceAdditionalSchema, builderOption: required },
        isInformationCertified: { type: Boolean, builderOption: { validators: [Validators.required], defaultDisabled: true, defaultValue: false }}
    }
}